import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const status = err?.response?.status;
    if (status === 401) {
      localStorage.removeItem("token");
      if (!window.location.pathname.startsWith("/login") && !window.location.hash.includes("session_id=")) {
        window.location.href = "/login";
      }
    }
    // Period lock (423): admins may override with an explicit, recorded reason
    if (status === 423 && err.config && !err.config.headers?.["X-Override-Reason"]) {
      const detail = fmtError(err.response?.data?.detail);
      const isAdminMsg = /administrator you may override/i.test(detail);
      if (isAdminMsg && window.confirm(`⚠️ LOCKED ACCOUNTING PERIOD\n\n${detail}\n\nOverriding will change finalized books and will be recorded in the audit trail with your name.\n\nDo you want to override the period lock?`)) {
        const reason = (window.prompt("Reason for override (required, recorded in audit log):") || "").trim();
        if (reason) return api.request({ ...err.config, headers: { ...err.config.headers, "X-Override-Reason": reason } });
      }
    }
    return Promise.reject(err);
  }
);

export default api;

export const deleteReason = (what) => {
  const r = window.prompt(`Delete ${what}?\nIt will move to the Recycle Bin (admin can restore).\n\nReason (optional):`, "");
  return r === null ? null : r.trim();
};

export function fmtError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
